import { API_KEY, API_URL_WITHOUT_USER } from "../../Utils/API";
import {
  getDispatch,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../Utils/helper";
import { HttpUtil } from "../../Utils/http-utils";
import ROUTES from "../../Utils/routesConstants";
import {
  getToken,
  GET_PROFILE_VERIFICATIONS,
  getTempararyTokenProviderAssist,
  getCampaignsToken,
} from "../../Utils/types";

export const getProfileVerificationAction = () => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = window.location.pathname.includes("campaigns")
  ? `${API_URL_WITHOUT_USER}/Campaigns/GetProfileVerificationDetails/${getCampaignsToken()}`
  : `${API_URL_WITHOUT_USER}/ProfileVerification/GetProfileVerificationDetails`;
  // const url = `${API_URL_WITHOUT_USER}/ProfileVerification/GetProfileVerificationDetails`;
  return HttpUtil.makeGET(
    url,
    {},
    {
      Authorization: window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
        ? getTempararyTokenProviderAssist() : window.location.pathname.includes("campaigns") ? null
        : getToken(),
      ApiKey: API_KEY,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_PROFILE_VERIFICATIONS, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_PROFILE_VERIFICATIONS, {}, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const saveProfileVerificationAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = window.location.pathname.includes("campaigns")
  ? `${API_URL_WITHOUT_USER}/Campaigns/SaveProfileValidityDetail/${getCampaignsToken()}`
  : `${API_URL_WITHOUT_USER}/ProfileVerification/SaveProfileValidityDetail`;
  return HttpUtil.makePOST(url, e, {
    Authorization: window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
    ? getTempararyTokenProviderAssist()
    : getToken(),
    ApiKey: API_KEY,
  }).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("success", "Details updated successfully", dispatch);
    } else {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};

export const addAccrediationRowAction = (docType) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = window.location.pathname.includes("campaigns")
  ? `${API_URL_WITHOUT_USER}/Campaigns/AddBlankDocument/${getCampaignsToken()}?docType=${docType}`
  : `${API_URL_WITHOUT_USER}/FileManager/AddBlankDocument?docType=${docType}`;
  // const url = `${API_URL_WITHOUT_USER}/FileManager/AddBlankDocument?docType=${docType}`;
  return HttpUtil.makePOST(
    url,
    {},
    {
      Authorization: window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
      ? getTempararyTokenProviderAssist() : window.location.pathname.includes("campaigns") ? null
      : getToken(),
      ApiKey: API_KEY,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      dispatch(getProfileVerificationAction());
      isLoadingAction(false, dispatch);
    } else {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};

export const addDocTypeRowAction = (docType) => (dispatch) => {
  isLoadingAction(true, dispatch);
  // const url = `${API_URL_WITHOUT_USER}/FileManager/AddBlankDocument?docType=${docType}`;
  const url = window.location.pathname.includes("campaigns")
  ? `${API_URL_WITHOUT_USER}/Campaigns/AddBlankDocument/${getCampaignsToken()}?docType=${docType}`
  : `${API_URL_WITHOUT_USER}/FileManager/AddBlankDocument?docType=${docType}`;
  return HttpUtil.makePOST(
    url,
    {},
    {
      Authorization: window.location.pathname.includes(ROUTES.PROVIDER_ASSIST)
      ? getTempararyTokenProviderAssist() : window.location.pathname.includes("campaigns") ? null
      : getToken(),
      ApiKey: API_KEY,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
    } else {
      isLoadingAction(false, dispatch);
    }
  });
};
